import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { Navigate, useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const OnboardingPage: React.FC = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(user?.firstName || '');
  const [lastName, setLastName] = useState(user?.lastName || '');
  const [club, setClub] = useState(user?.club || '');
  const [phone, setPhone] = useState(user?.phone || '');
  const [source, setSource] = useState(user?.source || '');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    // Si actif, sortir d'ici
    if (user && user.status === 'active') {
      navigate('/');
    }
  }, [user, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    setError(null);
    setSuccess(null);

    try {
      setLoading(true);
      await authService.updateUser(user.id, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        club: club.trim(),
        phone: phone.trim(),
        source: source.trim(),
      });

      setSuccess(
        "Votre demande a été envoyée. Vous serez notifié par email lorsqu'un administrateur aura activé votre compte."
      );
    } catch (err) {
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-4">Compléter votre profil</h1>
      <p className="text-gray-600 mb-6">
        Merci de compléter ces informations. Votre compte restera temporairement inactif jusqu'à validation par un administrateur.
      </p>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>
      )}
      {success && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">{success}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Prénom</label>
          <input
            className="w-full border rounded px-3 py-2"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Nom</label>
          <input
            className="w-full border rounded px-3 py-2"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Club</label>
          <input
            className="w-full border rounded px-3 py-2"
            value={club}
            onChange={(e) => setClub(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Téléphone</label>
          <input
            className="w-full border rounded px-3 py-2"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Source</label>
          <input
            className="w-full border rounded px-3 py-2"
            value={source}
            onChange={(e) => setSource(e.target.value)}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white rounded px-4 py-2 disabled:opacity-50"
        >
          {loading ? 'Envoi…' : 'Envoyer ma demande'}
        </button>
      </form>
    </div>
  );
};

export default OnboardingPage;
